import React, { Component } from 'react';

import PropTypes from 'prop-types';

import ReCAPTCHAWidget from 'common/common/ReCAPTCHAWidget';
import parseAPIResponse, { isDefaultSuccessResponse } from 'common/util/parseAPIResponse';

import AJAX from './AJAX';
import Button from './inputs/Button';
import TextInput from './inputs/TextInput';
import Strings from './Strings';
import Tappable from './Tappable';
import validateInput from './validateInput';

import 'css/components/_EmailSignupForm.scss';

export default class EmailSignupForm extends Component {
  static propTypes = {
    email: PropTypes.string,
    onBackClicked: PropTypes.func.isRequired,
    onForgotPasswordClicked: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
  };

  state = {
    error: null,
    submitting: false,
  };

  constructor(props) {
    super(props);

    this.captchaWidgetRef = React.createRef();
    this.emailRef = React.createRef();
    this.nameRef = React.createRef();
    this.passwordRef = React.createRef();
    this.confirmRef = React.createRef();
  }

  onSubmit = async (e) => {
    e.preventDefault();

    if (this.state.submitting) {
      return;
    }

    const email = this.emailRef.current.getValue().trim();
    const name = this.nameRef.current.getValue().trim();
    const password = this.passwordRef.current.getValue();
    const confirmPassword = this.confirmRef.current.getValue();

    if (!validateInput.userName(name)) {
      this.setState({
        error: Strings.invalidName,
      });
      return;
    }
    if (!validateInput.email(email)) {
      this.setState({
        error: Strings.invalidEmail,
      });
      return;
    }
    if (!validateInput.password(password)) {
      this.setState({
        error: Strings.invalidPassword,
      });
      return;
    }
    if (password !== confirmPassword) {
      this.setState({
        error: Strings.passwordConfirmMismatch,
      });
      return;
    }

    const captcha = await this.captchaWidgetRef?.current.getCAPTCHA();
    AJAX.post('/api/viewer/signup', { captcha, email, name, password }, this.onSignupResponse);

    this.setState({
      error: null,
      submitting: true,
    });
  };

  onSignupResponse = (response) => {
    const { error } = parseAPIResponse(response, {
      isSuccessful: isDefaultSuccessResponse,
      errors: {
        'email domain is not trusted':
          'Canny does not accept disposable email addresses. Please use another email address.',
        'email exists': Strings.emailTaken,
        'invalid captcha':
          'Our servers failed to verify your identity. Please wait a few minutes before trying again.',
        'missing captcha':
          "Our servers couldn't verify your identity. Please wait a few minutes before trying again.",
        'slow down':
          'You are trying to sign up too many times. Please wait a few minutes before trying again.',
        'password is too weak': 'Please enter a stronger password.',
      },
    });

    if (!error) {
      this.setState(
        {
          submitting: false,
        },
        () => this.props.onSuccess()
      );
      return;
    }

    if (error.type === 'invalid captcha') {
      this.captchaWidgetRef?.current.refresh();
    }

    this.setState({
      submitting: false,
      error: error.message,
    });
  };

  renderErrorMessage() {
    if (!this.state.error) {
      return;
    }

    return <div className="error">{this.state.error}</div>;
  }

  render() {
    const { email } = this.props;
    return (
      <div className="emailSignupForm">
        <div className="topContainer">
          <h1>Sign up with Email</h1>
          <form onSubmit={this.onSubmit}>
            <TextInput autoFocus={true} placeholder="Full name" ref={this.nameRef} />
            <TextInput defaultValue={email ? email : ''} placeholder="Email" ref={this.emailRef} />
            <TextInput placeholder="Password" ref={this.passwordRef} type="password" />
            <TextInput placeholder="Confirm password" ref={this.confirmRef} type="password" />
            {this.renderErrorMessage()}
            <ReCAPTCHAWidget ref={this.captchaWidgetRef} />
            <div className="buttonContainer">
              <Tappable onTap={this.props.onBackClicked}>
                <span className="greyLink">Cancel</span>
              </Tappable>
              <Button
                formButton={true}
                loading={this.state.submitting}
                tint={true}
                value="Sign up"
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}
